import classNames from "classnames";
import { FC } from "react";
import { API } from "../../../../services/api/types";
import Placeholder from "../../../Placeholder";
import styles from "./styles.module.css";
import Image from 'next/image';

type NextArticleProps = {
  isVisible: boolean;
  article: API.Article;
  progress: number;
  yOffset: number;
};

const NextArticle: FC<NextArticleProps> = (props) => {
  const scrollTo = (pos: number) => () => {
    window.scrollTo({ top: pos, behavior: "smooth" });
  };

  return (
    <div
      onClick={scrollTo(props.yOffset)}
      className={classNames(
        "cursor-pointer",
        "select-none",
        "sticky",
        "bottom-0",
        "w-full",
        "bg-white",
        "bg-opacity-95",
        "overflow-hidden",
        "transition-transform",
        "duration-200",
        // had to use 900 z-index to make sure it was on top of VI
        "z-[900]",
        styles["container"]
      )}
      style={{
        transform: `translateY(${props.isVisible ? "0" : "100%"})`,
      }}
    >
      <div className={classNames("w-full", "h-[4px]", "bg-gray-200")}>
        <div
          className={classNames(
            "bg-green",
            "h-full",
            "w-full",
            "transition-transform",
            "duration-50"
          )}
          style={{ transform: `translateX(${(-1 + props.progress) * 100}%)` }}
        />
      </div>
      <div className={classNames("p-2")}>
        <div className={classNames("flex")}>
          {props.article.imageSmall ? (
            <div className='mr-2'>
              <Image
                src={`${process.env.NEXT_PUBLIC_ASSET_SERVER_URL}${props.article.imageSmall}`}
                width={80}
                height={50}
                className="object-cover"
                alt="Artikelbild" // TODO: Get image description from DB
              />
            </div>
          ) : (
            <div className={classNames("mr-2")}>
              <Placeholder width={80} height={50} />
            </div>
          )}
          <div>
            <p
              className={classNames("text-sm", "font-semibold", "select-none")}
            >
              Nästa nyhet (scrolla ned)
            </p>
            <h3 className={classNames("text-sm", "select-none")}>
              {props.article.title}
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NextArticle;
